import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=6c5aedcf&"
import script from "./Response.vue?vue&type=script&lang=js&"
export * from "./Response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports